export const navArray = [
    {
        name: 'Игровая валюта',   
        path: '/',
        onlyMobile: false
    },  
    {
        name: 'Контакты',   
        path: '/contacts',
        onlyMobile: false
    },
    {
        name: 'Условия пользования',   
        path: '/term-and-conditions',
        onlyMobile: true
    },
    {
        name: 'Политика конфиденциальности, возврата и доставки',   
        path: '/policy',
        onlyMobile: true
    },
    {
        name: 'Политика куки',   
        path: '/cookie-policy',
        onlyMobile: true
    },
    {
        name: 'Поддержка',   
        path: '/support',
        onlyMobile: false
    }  
]